// middleware/age-verification.global.ts
import { useGeneralStore } from '~/store'

export default defineNuxtRouteMiddleware((to) => {
	if (import.meta.server) return

	const general = useGeneralStore()

	const nuxtApp = useNuxtApp()

	const { $i18n } = nuxtApp
	const currentLocale = $i18n.locale.value
	const localePath = useLocalePath()
	const getLocalizedPath = (path: string) => localePath(path, currentLocale)

	const normalize = (p: string) => p.replace(/\/+$/, '') || '/'

	// Normaliza el path actual (sin query/hash)
	const current = normalize(to.path)

	// Permite la ruta offline en PWA para evitar redirecciones del age gate sin conexión.
	const isOfflinePath = /^\/(?:(?:pt|fr)\/)?offline(?:\.html)?$/.test(current) || current.endsWith('/offline')
	if (isOfflinePath) return

	// Solo preservamos query/hash en rutas sensibles (links de email, activación, etc.)
	const shouldPreserve = current.startsWith('/auth') || current.startsWith('/activate-account')

	const go = (path: string) => {
		const localized = normalize(getLocalizedPath(path))

		// Evita loops
		if (current === localized) return

		return navigateTo(shouldPreserve ? { path: localized, query: to.query, hash: to.hash } : localized, {
			replace: true,
		})
	}

	// 🟡 CASO NUEVO:
	// Si el usuario borró cookies (is_adult === null) y está en /access-denied,
	// redirígelo al home según idioma para mostrar el modal
	const isAccessDenied = current.endsWith('/access-denied')
	if (general.is_adult === null && isAccessDenied) return go('/')

	if (general.is_adult === null) return

	// Adulto: si está en /access-denied, envíalo al home
	if (general.is_adult === true && isAccessDenied) return go('/')

	// Menor: si intenta acceder a algo que no sea /access-denied, redirígelo
	if (general.is_adult === false && !isAccessDenied) return go('/access-denied')
})
